(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebd-contact-forms"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.buttons-wrapper button');
    const forms = document.querySelectorAll('.forms-wrapper .form');
    const formsAnchor = document.getElementById('forms-anchor');

    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const formId = button.getAttribute('data-form-id');

        forms.forEach(form => {
          if (form.getAttribute('data-form-id') === formId) {
            form.style.display = 'block';
          } else {
            form.style.display = 'none';
          }
        });

        // Scroll to #forms-anchor at 768px media size
        if (window.innerWidth <= 768) {
          formsAnchor.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module--alix-earle-internship-hero"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.swiper-container', {
        slidesPerView: 1.15,
        spaceBetween: 10,  
        breakpoints: {
          600: {
            slidesPerView: 1.75,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 2.25,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 3.25,
            spaceBetween: 20,
          },
          1400: {
            slidesPerView: 5,
          }
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module--featured-media"] && !window.DesignMode) return;
  try {
    
window.addEventListener("scroll", () => {
  const scrollY = window.scrollY;

  const cans = [
    { id: "#floating-can-1", baseRotate: 6, rotateDir: -1 },
    { id: "#floating-can-2", baseRotate: -6, rotateDir: 1 },
    { id: "#floating-can-3", baseRotate: 6, rotateDir: 1 },
    { id: "#floating-can-4", baseRotate: -6, rotateDir: -1 },
  ];

  cans.forEach(({ id, baseRotate, rotateDir }, index) => {
    const can = document.querySelector(id);
    const translateY = -scrollY * 0.25 * (1 + index * 0.005); // more upward movement
    const rotate = baseRotate + rotateDir * scrollY * 0.005; // less rotation

    can.style.transform = `translateY(${translateY}px) rotate(${rotate}deg)`;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module--product-carousel-lifestyle"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiperContainers = document.querySelectorAll('.reviews .swiper-container');
    swiperContainers.forEach(container => {
      new Swiper(container, {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: 1,
        loop: true,
        fadeEffect: {
          crossFade: true
        },
        effect: 'fade'
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module--puck-review"] && !window.DesignMode) return;
  try {
    
  // Embed script from Puck that references specific div ID
  (function(){
    if (window.__puckEmbedLoaded) {
      window.Puck?.loadPlayers?.();
      return;
    }

    window.__puckEmbedLoaded = true;

    let script = document.createElement("script");
    script.onload = () => window.Puck?.loadPlayers?.();
    script.src = "https://embed.careerpuck.com/player.js";
    script.async = true;
    document.head.appendChild(script);
  })();

  } catch(e) { console.error(e); }
})();
})();
